import React from 'react';

const BalanceBadge = ({ balanced, label }) => (
  <span
    className={`px-2 py-1 rounded-md text-xs font-medium tabular-nums ${
      balanced ? 'bg-success-50 text-success-700' : 'bg-danger-50 text-danger-700'
    }`}
  >
    {label}
  </span>
);

export default BalanceBadge;
